var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5085 4.5C22.061 4.5 22.509 4.94772 22.509 5.5V9C22.509 9.55228 22.061 10 21.5085 10H18.0068C17.4542 10 17.0063 9.55228 17.0063 9C17.0063 8.44772 17.4542 8 18.0068 8H19.2993C17.8877 6.75451 16.0343 6 14.0048 6C9.88568 6 6.49211 9.11098 6.04984 13.1099C5.98913 13.6588 5.49469 14.0546 4.94549 13.9939C4.39628 13.9333 4.00027 13.4391 4.06099 12.8901C4.61409 7.88912 8.85438 4 14.0048 4C16.4881 4 18.7597 4.90468 20.508 6.40058V5.5C20.508 4.94772 20.9559 4.5 21.5085 4.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0642 14.0061C23.6134 14.0667 24.0094 14.5609 23.9487 15.1099C23.3956 20.1109 19.1553 24 14.0048 24C11.5216 24 9.24997 23.0953 7.50167 21.5994V22.5C7.50167 23.0523 7.05374 23.5 6.50119 23.5C5.94863 23.5 5.5007 23.0523 5.5007 22.5V19C5.5007 18.4477 5.94863 18 6.50119 18H10.0029C10.5554 18 11.0034 18.4477 11.0034 19C11.0034 19.5523 10.5554 20 10.0029 20H8.71043C10.122 21.2455 11.9754 22 14.0048 22C18.124 22 21.5176 18.889 21.9598 14.8901C22.0205 14.3412 22.515 13.9454 23.0642 14.0061Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncOutline);
export default __webpack_public_path__ + "static/media/sync_outline.afe852b53167b6821b725be94d9791a0.svg";
export { ForwardRef as ReactComponent };